import { useEffect, useRef } from "react";
import api from "@/lib/api";

// Polls the CRM change counter and calls onChange whenever anyone writes CRM data.
export function useLiveRev(onChange, ms = 4000) {
  const cb = useRef(onChange);
  cb.current = onChange;
  useEffect(() => {
    let last = null;
    let alive = true;
    const tick = async () => {
      if (document.hidden) return;
      try {
        const { data } = await api.get("/crm/rev");
        if (!alive) return;
        if (last !== null && data.v !== last) cb.current();
        last = data.v;
      } catch { /* offline: try next tick */ }
    };
    tick();
    const t = setInterval(tick, ms);
    const vis = () => { if (!document.hidden) tick(); };
    document.addEventListener("visibilitychange", vis);
    return () => { alive = false; clearInterval(t); document.removeEventListener("visibilitychange", vis); };
  }, [ms]);
}
